import React from 'react';
import Checkbox from '../../../Shared/Checkbox/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import { moduleActions } from '../../../../redux/modules';
import { getRothConversionTermsConditions } from '../../../../redux/modules/rothConversionTransaction/rothConversionTransaction.selectors';
import './RothConversionTermsAndConditions.scss';
import TRP from '../../../Shared/TRP/TRP';
import config from '../../../../config/config';

const RothConversionTermsAndConditions = () => {
  const userAgrees = useSelector(getRothConversionTermsConditions);
  const dispatch = useDispatch();
  const { updateTermsAndConditions } = moduleActions;
  return (
    <div className="roth-conversion-terms">
      <p>
        I agree to be bound by the terms of the prospectus for each <TRP /> fund
        (Fund) in which I am investing. I have the authority and legal capacity
        to purchase mutual funds, and am of legal age in my state. I received
        and read the prospectus and the{' '}
        <a
          href={`${config.url}/content/dam/iinvestor/Forms/tradRothIraAgree.pdf`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {' '}
          <TRP /> Traditional and Roth IRA Disclosure Statement and Custodial
          Agreement
        </a>{' '}
        and I agree to the terms and conditions contained within those
        documents. I understand that these documents may be amended from time to
        time
      </p>
      <p>
        <label>
          <Checkbox
            inline
            checked={userAgrees}
            ariaLabel="final agreemnet"
            id="checkbox_final_agreement"
            name="manualBankAgreementConsent"
            onClick={() => dispatch(updateTermsAndConditions(!userAgrees))}
          />{' '}
          <span className="roth-conversion-terms_inputs">I Agree</span>
        </label>
      </p>
    </div>
  );
};

export default RothConversionTermsAndConditions;
